const KL_VIDEO_CAROUSEL_SECTION_SELECTOR = '[data-kl-video-carousel]';
const KL_VIDEO_CAROUSEL_CARD_SELECTOR = '[data-kl-video-carousel-card]';
const klVideoCarouselPreviews = new WeakMap();

function getSectionPreview(sectionElement) {
  if (!klVideoCarouselPreviews.has(sectionElement)) {
    klVideoCarouselPreviews.set(sectionElement, { previewingVideo: null });
  }

  return klVideoCarouselPreviews.get(sectionElement);
}

function initVideoCarouselCard(card, sectionElement) {
  if (card.dataset.klVideoCarouselPlaybackReady === 'true') return;

  const video = card.querySelector('[data-kl-video-carousel-video]');
  const openButton = card.querySelector('[data-kl-video-carousel-open]');

  if (!video || !openButton) return;

  card.dataset.klVideoCarouselPlaybackReady = 'true';

  const sectionPreview = getSectionPreview(sectionElement);

  const isMutedByChoice = video.muted;

  function showPlayingState() {
    if (sectionPreview.previewingVideo && sectionPreview.previewingVideo !== video) {
      sectionPreview.previewingVideo.pause();
    }

    sectionPreview.previewingVideo = video;
    card.classList.add('is-playing');
  }

  function showPausedState() {
    if (sectionPreview.previewingVideo === video) sectionPreview.previewingVideo = null;

    card.classList.remove('is-playing');
  }

  function requestPlayback() {
    const playRequest = video.play();

    if (playRequest && typeof playRequest.catch === 'function') {
      playRequest.catch((error) => {
        if (error.name === 'AbortError') return;

        console.debug('kl-video-carousel: the browser refused to preview this video', {
          source: video.currentSrc,
          error,
        });
        showPausedState();
      });
    }
  }

  function startPreview(event) {
    if (event.pointerType !== 'mouse') return;

    if (sectionElement.hasAttribute('data-kl-video-carousel-panel-open')) return;

    if (!video.paused) return;

    video.muted = true;
    requestPlayback();
  }

  function endPreview() {
    video.pause();
    video.muted = isMutedByChoice;

    video.load();
    showPausedState();
  }

  function handlePointerLeave(event) {
    if (event.pointerType !== 'mouse') return;

    endPreview();
  }

  card.addEventListener('pointerenter', startPreview);
  card.addEventListener('pointerleave', handlePointerLeave);

  openButton.addEventListener('click', endPreview);

  video.addEventListener('play', showPlayingState);
  video.addEventListener('pause', showPausedState);
  video.addEventListener('ended', showPausedState);
}

function initVideoCarouselPlayback(sectionElement) {
  sectionElement
    .querySelectorAll(KL_VIDEO_CAROUSEL_CARD_SELECTOR)
    .forEach((card) => initVideoCarouselCard(card, sectionElement));
}

function initVideoCarouselPlaybackWithin(rootElement) {
  rootElement.querySelectorAll(KL_VIDEO_CAROUSEL_SECTION_SELECTOR).forEach(initVideoCarouselPlayback);
}

initVideoCarouselPlaybackWithin(document);

document.addEventListener('shopify:section:load', (event) => {
  initVideoCarouselPlaybackWithin(event.target);
});

document.addEventListener('kl:content:added', (event) => {
  const injectedRoot = event.detail && event.detail.root;

  if (!injectedRoot || typeof injectedRoot.closest !== 'function') return;

  const sectionElement = injectedRoot.closest(KL_VIDEO_CAROUSEL_SECTION_SELECTOR);

  if (sectionElement) initVideoCarouselPlayback(sectionElement);

  initVideoCarouselPlaybackWithin(injectedRoot);
});
